/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import "./display-sam-2024.scss";


type DisplaySam2024Props = {
    ready: boolean,
    cartUrl: string,
    cartExpired: boolean,
    productCount: number,
    remainingTimeString: string,
    displayTime: boolean,
    expiresSoon: boolean,
    showLogout: boolean,
    onLogoutClick: () => void,
    onCartClick: () => void,
};

export function DisplaySam2024({ ready, productCount, /*expiresSoon, displayTime, remainingTimeString, cartExpired, showLogout, onLogoutClick,*/ onCartClick }: DisplaySam2024Props) {
 
    if (!ready)
        return <span></span>;

    return <div className="display-sam-2024">

        {/* Be careful with what you use here because this controle MUST defines its own width according
            to it's content since the width is sent the the frame owner and then resized accordingly  */}
        {/* TODO: Refactor this as a button */}
        {/* eslint-disable-next-line sonarjs/anchor-is-valid */}
        <a onClick={onCartClick} onKeyDown={(e) => { if (e.key === 'Enter') onCartClick(); }} target="_top">
            <div className="cart-status-box">
                <ComotionCartIcon />
                {productCount > 0 && <div className="product-count">{productCount}</div>}

            </div>
        </a>
    </div>;
}

function ComotionCartIcon() {
    return <svg width="20" height="20" viewBox="0 0 18 18" fill="currentColor">
        <path d="m 5.172231,17.1765 c -0.41372,0 -0.76642,-0.1473 -1.05809,-0.4419 -0.29166,-0.2946 -0.4375,-0.6488 -0.4375,-1.0625 0,-0.4137 0.14731,-0.7664 0.44192,-1.0581 0.29463,-0.2916 0.64879,-0.4375 1.0625,-0.4375 0.41372,0 0.76642,0.1473 1.05809,0.442 0.29166,0.2946 0.4375,0.6487 0.4375,1.0625 0,0.4137 -0.14731,0.7664 -0.44192,1.058 -0.29463,0.2917 -0.64879,0.4375 -1.0625,0.4375 z m 9.000047,0 c -0.4138,0 -0.7665,-0.1473 -1.0581,-0.4419 -0.2917,-0.2946 -0.4375,-0.6488 -0.4375,-1.0625 0,-0.4137 0.1473,-0.7664 0.4419,-1.0581 0.2946,-0.2916 0.6488,-0.4375 1.0625,-0.4375 0.4137,0 0.7664,0.1473 1.0581,0.442 0.2916,0.2946 0.4375,0.6487 0.4375,1.0625 0,0.4137 -0.1473,0.7664 -0.4419,1.058 -0.2947,0.2917 -0.6488,0.4375 -1.0625,0.4375 z M 5.241871,4.67653 l 1.45832,3.4583 h 6.223787 l 1.4021,-3.4583 z M 4.407621,2.82324 h 12.810757 l -3.0915,7.17665 H 6.481001 l -0.76902,1.32331 h 10.141297 v 1.8533 H 2.480981 L 4.997291,8.87489 2.362331,2.67653 H 0.5 V 0.823242 h 3.053461 z"
            fill="currentColor"
            id="path1"
            style={{ strokeOpacity:1 }} />
    </svg>;
}